import React, { useState } from "react";
import { BsPlusLg } from "react-icons/bs";
import MultiInputDataTag from "./MultiInputDataTag";

const NestedInputMultiple = ({ item }) => {
  const { label, name, type, multiple, multipleData, required } = item;

  const [quantityCount, setCount] = useState(
    multipleData
      ? multipleData
      : [
          {
            label: label,
            type: "text",
            name: "",
            defaultValue: [],
          },
        ]
  );
  const handleAddElement = () => {
    setCount((current) => [
      ...current,
      {
        label: label,
        type: "text",
        name: "",
        defaultValue: [],
      },
    ]);
  };

  return (
    <div className="lg:col-span-3 flex flex-row gap-4 items-centers w-full fitHeight  ">
      <div className=" w-full ">
        {quantityCount.map((item, index) => (
          <MultiInputDataTag
            key={index}
            label={label}
            length={index + 1}
            name={name}
            defaultTitle={item.defaultValue.title}
            defaultParagraph={item.defaultValue.paragraph}
            defaultImage={item.defaultValue.image}
            type={type}
            required={required}
          />
        ))}
      </div>

      {multiple && (
        <div className="flex justify-center items-end">
          <button
            onClick={handleAddElement}
            type="button"
            className="btn btn-circle"
          >
            <BsPlusLg />
          </button>
        </div>
      )}
    </div>
  );
};

export default NestedInputMultiple;
